import { useParams, useNavigate } from "react-router-dom";
import { useAtomValue, useSetAtom } from "jotai";
import classNames from "classnames";
import { useMemo } from "react";

import BrieIconOutlined from "../../BrieChatMenu/BrieIconOutlined";
import { sidebarOpenAtom } from "../../../atoms/SidebarAtoms";
import { IsMobileAtom } from "../../../App";
import { Link } from "../IconLink";

interface Props {
  sidebarOpen: boolean;
  link: Link;
}

const customIcons = {
  "brie-icon": <BrieIconOutlined />,
};

const BasicCustomLink = ({ sidebarOpen, link }: Props) => {
  const navigate = useNavigate();
  const { tenantID } = useParams<any>();
  const mobileScreen = useAtomValue(IsMobileAtom);
  const setSidebarOpen = useSetAtom(sidebarOpenAtom);

  const active = useMemo(() => {
    return location.pathname === `/clouds/${tenantID}/${link.path}`;
  }, [location.pathname, link]);

  const baseSidebarLinkCss =
    "tw:text-[13px] tw:transition tw:delay-50 tw:duration-300 tw:ease-in-out tw:hover:border tw:hover:border-superlight tw:hover:bg-sidebar-link tw:font-medium tw:text-dark tw:cursor-pointer tw:rounded-md tw:block tw:no-underline";

  //@ts-ignore
  const customIcon = customIcons[link.icon];

  return (
    <>
      <div
        className={classNames(
          `${baseSidebarLinkCss} tw:flex tw:items-center tw:mx-3 tw:mb-2`,
          {
            "tw:px-2": sidebarOpen,
            "tw:justify-center tw:px-0": !sidebarOpen,
            [link?.css ?? ""]: !!link?.css,
            "tw:bg-primary-light-bg tw:border tw:border-primary-light": active,
            "tw:border tw:border-transparent": !active,
          }
        )}
        style={{ height: 34 }}
        onClick={() => {
          navigate(`/clouds/${tenantID}/${link.path}`);

          // Close sidebar on mobile on click
          if (mobileScreen) setSidebarOpen(false);
        }}
      >
        {customIcon ? (
          customIcon
        ) : (
          <i
            className={`${link.icon} tw:text-primary`}
            style={{ fontSize: 18 }}
          />
        )}

        {sidebarOpen && <div className="tw:pl-2 tw:mb-0">{link.name}</div>}
      </div>
    </>
  );
};

export default BasicCustomLink;
